
export const setUser = (user) => {
    return {
        type: 'SET_USER',
        user,
    };
};

export const getUser = (user) => {
    return {
        type: 'LOAD_USER',
        user,
    };
};

export const setVision = (vision) => {
    return {
        type: 'SET_USER_VISION',
        vision,
    };
};

export const setCulture = (culture) => {
    return {
        type: 'SET_USER_CULTURE',
        culture,
    };
};

export const setWarehouse = (warehouse) => {
    return {
        type: 'SET_USER_WAREHOUSE',
        warehouse,
    };
};

export const setResource = (resource, resourceObj) => {
    return {
        type: 'SET_USER_RESOURCE',
        resource,
        resourceObj
    };
};

export const setResourceLaser = (resource) => {
    return {
        type: 'SET_USER_RESOURCE_LASER',
        resource
    };
};

export const setEquipment = (equipment, equipmentObj) => {
    return {
        type: 'SET_USER_EQUIPMENT',
        equipment,
        equipmentObj
    };
};

export const setTypePrint = (typePrint) => {
    return {
        type: 'SET_TYPE_PRINT',
        typePrint,
    };
};

export const setDock = (dock, dockObj) => {
    return {
        type: 'SET_USER_DOCK',
        dock,
        dockObj
    };
};

export const setShed = (shed, shedObj) => {
    return {
        type: 'SET_USER_SHED',
        shed,
        shedObj
    };
};

export const setPrinter = (printer) => {
    return {
        type: 'SET_PRINTER',
        printer,
    };
};

export const setTheme = (theme) => {
    return {
        type: 'SET_THEME',
        theme,
    };
};

export const resetResourceShedDock = () => {
    return {
        type: 'RESET_RESOURCE_SHED_DOCK',
    };
};


export const setResourceConfig = (resource, resourceObj) => {
    return {
        type: 'SET_USER_RESOURCE',
        resource,
        resourceObj,
        config: true

    };
};

export const setResourceLaserConfig = (resource) => {
    return {
        type: 'SET_USER_RESOURCE_LASER',
        resource,
        config: true

    };
};

export const setEquipmentConfig = (equipment, equipmentObj) => {
    return {
        type: 'SET_USER_EQUIPMENT',
        equipment,
        equipmentObj,
        config: true

    };
};

export const setTypePrintConfig = (typePrint) => {
    return {
        type: 'SET_TYPE_PRINT',
        typePrint,
        config: true
    };
};

export const setDockConfig = (dock, dockObj) => {
    return {
        type: 'SET_USER_DOCK',
        dock,
        dockObj,
        config: true

    };
};

export const setShedConfig = (shed, shedObj) => {
    return {
        type: 'SET_USER_SHED',
        shed,
        shedObj,
        config: true

    };
};

export const setPrinterConfig = (printer) => {
    return {
        type: 'SET_PRINTER',
        printer,
        config: true
    };
};

export const setUnitConfig = (unit) => {
    return {
        type: 'SET_USER_UNIT',
        unit,
        config: true
    };
};